export default {
  most_popular: 'Más Popular',
  tiered_input: {
    label: '¿Cuántos usuarios hay en tu equipo?',
    description: '* Los descuentos empiezan a partir de 15 usuarios',
  },
  currency: 'Moneda',
  currencies: {
    mxn: 'MXN',
    usd: 'USD',
  },
  recurrances: {
    day: 'Diario',
    days: 'Dias',
    week: 'Semanal',
    weeks: 'Semanas',
    month: 'Mensual',
    months: 'Meses',
    year: 'Anual',
    years: 'Años',
  },
  free_trial: 'Comienza tu periodo de prueba de {numberOfDays} días',
  units: 'usuarios',
  unit: 'por usuario',
  yearly_tooltip_help: '(los decimales pueden variar)',
  free_tooltip: 'Siempre gratis',
  time: {
    day: 'por Día',
    days: 'por Días',
    week: 'por Semana',
    weeks: 'por Semanas',
    month: 'por Mes',
    months: 'por Meses',
    year: 'por Año',
    years: 'por Años',
  },
  actions: {
    buy_now: 'Comprar Ahora',
    contact_sales: 'Contactar a Ventas',
  },
  discount_badge_for_yearly: 'Ahorra 16%',
  footer: '* Los precios no incluyen impuestos <br /> * Pregunta por nuestros descuentos para negocios pequeños',
};
